const LabelMap = {
  OCPPEndpoint: "OCPP Endpoint (URL)",
  OCPPChargePointIdentifier: "OCPP Charge Point Identifier (KEY)",
};

export function prettifyName(name) {
  if (!name) {
    return "--Undefined--";
  }

  return name
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
}

export function getLabel(name, t) {
  if (LabelMap[name]) {
    return t ? t(`config.${name}`, { defaultValue: LabelMap[name] }) : LabelMap[name];
  }

  if (!name) {
    return t ? t("common.undefined") : "--Undefined--";
  }

  return prettifyName(name);
}
